import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { StyledDialogContent } from '~/components/dialog/styles/styled-dialog';
import { breakPoints } from '~/styles/break-points';

export const StyledConflictSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_300};
`;

export const StyledConflictDialogWrapper = styled.div`
	${StyledDialogContent} {
		padding-top: 0;

		${breakPoints({
			'1024': `
				padding-top: 0;
			`,
		})}
	}
`;

export const StyledConflictDialog = styled.div`
	display: flex;
	flex-direction: column;
	gap: 48px;
	padding-top: 48px;

	${breakPoints({
		'1024': `
			padding-top: 64px;
		`,
	})}
`;

export const StyledSelectionArea = styled.div`
	display: flex;
	flex-direction: column;

	& > p:first-of-type {
		margin-bottom: 4px;
	}

	.border-area {
		display: flex;
		flex-direction: column;
		border: 1px solid #666666;
		margin-top: 24px;
	}
`;
